import { fromJS } from 'immutable';
import {
    HIDE_PRODUCT_IN_SELECTOR,
    SHOW_PRODUCT_IN_SELECTOR,
    SET_VISIBLE_PRODUCTS
} from '../actions/productVisibilityActions';

const initialState = fromJS({
    visibleProductIds: [], // Array of product IDs that are visible in the selector
});

export default function productVisibilityReducer(state = initialState, action) {
    switch (action.type) {
        case HIDE_PRODUCT_IN_SELECTOR:
            // Remove the product ID from visible products
            return state.update('visibleProductIds', ids => {
                const idsArray = ids.toJS ? ids.toJS() : ids;
                return fromJS(idsArray.filter(id => id !== action.payload));
            });

        case SHOW_PRODUCT_IN_SELECTOR:
            // Add the product ID back to visible products if it's not already there
            return state.update('visibleProductIds', ids => {
                const idsArray = ids.toJS ? ids.toJS() : ids;
                return fromJS(idsArray.includes(action.payload) ? idsArray : [...idsArray, action.payload]);
            });

        case SET_VISIBLE_PRODUCTS:
            // Set the complete list of visible products
            return state.set('visibleProductIds', fromJS(action.payload));

        default:
            return state;
    }
}
